import "../../../../src/pages/design/design-guidelines-styles.css";
import { DemoModal } from "../../../../src/components/DemoModal";
import * as React from 'react';
export default {
  DemoModal,
  React
};